/**
 * Handler /impersonate?token=xxx · appelé par la Console super-admin
 * pour ouvrir une session "en tant que" un utilisateur du tenant.
 *
 * Pose l'access token en mémoire (window) puis redirige vers /.
 * Le token contient un claim `imp.by` qui déclenche l'affichage du
 * bandeau persistant `ImpersonationBanner`. TTL géré par le JWT exp.
 */
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { setAccessToken } from "../lib/api";

export function ImpersonatePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("Token d'impersonation absent.");
      return;
    }
    setAccessToken(token);
    // Force un reload complet : l'AuthContext refetch /me avec le nouveau
    // token, et tout l'app utilise immédiatement la nouvelle identité.
    window.location.replace("/");
  }, [params, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-navy-50 p-6">
        <div className="max-w-md rounded-2xl bg-white p-6 ring-1 ring-red-200">
          <h1 className="text-xl font-bold text-red-700">Impersonation impossible</h1>
          <p className="mt-2 text-sm text-navy-600">{error}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-50">
      <p className="text-sm text-navy-500">Ouverture de la session…</p>
    </div>
  );
}
